import axios from "axios";
import { config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Add New supplier
export const add_admin = async (values) => {
    let response = await axios.post(baseURL + "/central-admin", values);
    return response.data;
}
export const get_all_admins = async () => {
    let response = await axios.get(baseURL + '/central-admin')
    return response.data
}
// Delete Role
export const delete_admin = async (id: number) => {
    let response = await axios.delete(baseURL + "/central-admin/" + id);
    return response.data;
}
// Update CategoryApi
export const update_admin = async (id: number, formdata) => {
    let response = await axios.post(baseURL + "/update-central-admin/" + id,formdata,config_multipart);
    return response.data;
}
// Get All Admin Logs
export const get_all_admin_logs = async () => {
    let response = await axios.get(baseURL + "/all-central-admin-logs");
    return response.data;
}
// Get Single Admin Logs by ID
export const get_single_admin_logs = async (id: number) => {
    let response = await axios.get(baseURL + "/single-central-admin-log/" + id);
    return response.data;
  };